var _g, _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622",
    transform: "translate(-177 -343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad",
    transform: "translate(177 343)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 42.415,
    cy: 42.415,
    r: 42.415,
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M175.431,101.27a42.586,42.586,0,0,1-54.8,64.606,42.585,42.585,0,1,0,54.8-64.606Z",
    transform: "translate(-108.96 -93.997)",
    fill: "#dbdbdb",
    opacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3621",
    "data-name": "Group 3621",
    transform: "translate(18.993 24.802)",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 7.097,
    cy: 7.097,
    r: 7.097,
    fill: "#202020"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 7.097,
    cy: 7.097,
    r: 7.097,
    transform: "translate(32.651)",
    fill: "#202020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    d: "M170.511,297.688c11.51-8.028,24.283-7.981,35.726,0,1.379.958,2.621-.7,1.687-2.239a23.025,23.025,0,0,0-39.1,0C167.89,296.984,169.132,298.646,170.511,297.688Z",
    transform: "translate(-164.951 -260.484)",
    fill: "#202020"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataFoundIcon);
export default __webpack_public_path__ + "static/media/noDataFoundIcon.b7e8ba8d5bc858925431a4d5ce0e29e4.svg";
export { ForwardRef as ReactComponent };